export default function () {
    let $attachmentContainer = $('#attachments');

    if ($attachmentContainer.length) {
        let $attachmentInput = $attachmentContainer.find('input[type=file]'),
            $attachmentDelete = $attachmentContainer.find('.l-delete');

        if ($attachmentInput.length) {
            $.each($attachmentInput, function (index, ele) {
                let k_upload = $(ele).data('kendoUpload');
                if (k_upload) {
                    onUpload(k_upload);
                    onComplete(k_upload);
                }
            });
        }

        if ($attachmentDelete.length) {
            removeAttachment($attachmentDelete);
        }
    }
}

const onUpload = function (k_upload) {
    k_upload._events.upload = k_upload._events.upload || [];
    k_upload._events.upload.push(function (e) {
        let sectionName = $('#sectionName').val();
        if (sectionName === 'ProjectPage') {
            let $catSelect = $('#AttachmentCategory');
            if ($catSelect.length) {
                let k_catSelect = $catSelect.data('kendoDropDownList');
                if (k_catSelect) {
                    sectionName = k_catSelect.value();
                }
            }
        }
        
        e.data = {
            pid: parseInt($('#Project_Pid').val()), mid: $('#Id').val() || -1, section: sectionName
        };
    });
};

const updateFileUiOnError = function(loc, attId, file, error) {
    const ttl = $('.k-file-name[data-uid="' + loc.uid + '"]');
    ttl.attr('title', file.name);
    ttl.html(file.name);

    setTimeout(() => {
        const li = $('.k-file[data-uid="' + loc.uid + '"]');
        li.addClass('k-file-error');
        li.removeClass('k-file-success');

        const validationMessageElement = li.find('.k-file-validation-message');
        validationMessageElement.html(error);
        validationMessageElement.removeClass('k-text-success');
        validationMessageElement.addClass('k-text-error');
    });
};

const updateFileUiOnSuccess = function(loc, attId, file) {
    const dla = $('[data-uid-download="' + loc.uid + '"]');
    dla.attr('href', '/Download/Attachment?attid=' + attId);
    const ra = $('[data-uid-remove="' + loc.uid + '"]');
    ra.attr('data-file-id', attId);
    const ttl = $('.k-file-name[data-uid="' + loc.uid + '"]');
    ttl.attr('title', file.name);
    ttl.html(file.name);
    return loc;
};

const processEachFileOnUploadSuccess = function(file, uIndex, locFiles, resp) {
    const attId = resp.Data[uIndex].Id;
    const error = resp.Data[uIndex].Error;

    locFiles.forEach(function(loc) {
        if (loc.name === file.name && loc.uid === file.uid) {
            if (error) {
                updateFileUiOnError(loc, attId, file, error);
                return;
            }

            updateFileUiOnSuccess(loc, attId, file);
        }
    });
};
const processUploadResult = function(k_upload, e) {
    const locFiles = k_upload.getFiles();
    const resp = JSON.parse(e.XMLHttpRequest.response);

    e.files.forEach(function(file, uIndex) {
        processEachFileOnUploadSuccess(file, uIndex, locFiles, resp);
        removeAttachment($(`.l-delete[data-uid-remove=${file.uid}]`));
    });

    k_upload._showHeaderUploadStatus(false);
};

const processUploadResultProjectPage = function(k_upload) {
    k_upload._showHeaderUploadStatus(false);

    $('.js-attachment-grid')
        .data('kendoGrid')
        .dataSource.read();

    $('.k-file').remove();
};

const onComplete = function(k_upload) {
    k_upload._events.success = k_upload._events.success || [];

    k_upload._events.success.push(function(e) {
        if (e.operation !== 'upload') {
            return true;
        }

        let sectionName = $('#sectionName').val();

        if (sectionName === 'ProjectPage') {
            processUploadResultProjectPage(k_upload);
        }

        processUploadResult(k_upload, e);
        return true;
    });
};

const removeAttachment = function($attachmentDelete) {
    $attachmentDelete.click(function(event) {
        const ele = event.currentTarget;
        const attId = ele.getAttribute('data-file-id');
        const uid = ele.getAttribute('data-uid-remove');

        const $files = $('#files');
        const kendoUploadEle = $files.data('kendoUpload');

        if (!attId || attId === 'undefined' || attId === -1) {
            kendoUploadEle.clearFile(function(file) {
                if (!file) return false;
                return file[0].uid === uid;
            });

            return;
        }

        $.ajax({
            type: 'POST',
            url: '/Forms/ProjectReview/RemoveAttachment',
            data: 'attID=' + attId,
            success: function(attId, response) {
                if (response === 'success') {
                    kendoUploadEle.clearFile(function(file) {
                        if (!file) return false;
                        return file[0].uid === uid;
                    });
                }
            },
        });
    });
};